/* EmptyState - Shared on-brand empty state for category / listing pages
 * Updated: Removed the surrounding card styling so the empty state sits directly on the page.
 */

import { Sprout } from 'lucide-react';
import { motion } from 'framer-motion';

interface EmptyStateProps {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({ message, actionLabel, onAction }: EmptyStateProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
      className="flex flex-col items-center justify-center px-6 py-20 text-center"
    >
      <div className="relative mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-[#f5f2ec] ring-1 ring-[#e7e1d6]">
        <Sprout className="h-9 w-9 text-[#5a6552]" strokeWidth={1.5} />
      </div>
      <p className="max-w-sm text-lg leading-relaxed text-[#5a6552]">{message}</p>
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="mt-6 rounded-md bg-[#1e2b22] px-5 py-2.5 text-sm font-medium text-[#e7e1d6] transition-colors duration-200 hover:bg-[#2a3a30]"
        >
          {actionLabel}
        </button>
      )}
    </motion.div>
  );
}
